<script>
import { fandomBasicMixin, fandomExtendedMixin, fandomTileMixin } from "src/modules/fandom_mixins_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, fandomTileMixin],
  data() {
    return { };
  },
  methods: {
    openModal(button) {
      if (button.url == '$contactForm')
        $("#modal-contact-form").modal("show");
    }
  },
  computed: {
    url() {
      return get(this.content, ['url','url'], Fandom.getContentURL(this.content));
    }
  },
}
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType"
    :style="{'background-color': content.background_color || theme}"
    class="d-flex flex-column tile-shadow" 
    tile-contacts-component
  >
    <div :class="{'ar-16by9': !content.icon}" class="heading position-relative overflow-hidden">
      <div 
        v-if="content.thumbnail" 
        class="position-absolute-center bg-cover-center w-100 h-100 d-flex justify-content-center align-items-center" 
        :style="{'background-image': getContentResponsiveImageURL('thumbnail')}">
      </div>
      <div 
        v-if="content.icon" 
        class="position-absolute-center bg-cover-center icon w-100 h-100 d-flex justify-content-center align-items-center" 
        :style="{'background-image': getContentResponsiveImageURL('icon')}">
      </div>
    </div>
    <div class="d-flex flex-column justify-content-between text-center flex-grow-1 pt-0 px-3 mb-2">
      <div>
        <component
          v-if="content.title"
          :class="content.title_class || 'h5'"
          :is="content.title_tag || 'h4'"
          class="font-weight-bold"
        >
          {{content.title}}
        </component>
        <component
          v-if="content.subtitle"
          :is="content.subtitle_tag || 'div'"
          :class="content.subtitle_class"
          class="dotdotdot-subtitle"
          v-html="content.subtitle"
        >
        </component>
      </div>
      <div class="buttons-container d-flex flex-column mb-2 px-md-4">
        <a 
          v-for="button, index in content.buttons"
          :href="button.button.url.includes('$') ? 'javascript: void(0)' : button.button.url"
          :target="getTarget(button.button)"
          :class="[{'mb-2': index != content.buttons.length - 1}, button.button_class ]"
          @click="openModal(button.button)"
          class="btn cursor-pointer w-100">
          <i class="fal pr-2" :class="button.icon" v-if="button.icon"></i>
          {{ button.button.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[tile-contacts-component] {
  color: var(--theme-color) !important;

  .icon {
    background-size: 7rem;
  }

  .btn {
    font-size: 1rem;
  }

  .cursor-none {
    cursor: default;
  }

  .heading {
    border-radius: 0.5rem 0.5rem 0rem 0rem;
    padding-bottom: 42%;
  }
}
</style>